// NB! Note - RWS
// Configuration for the PRODUCTION Server - DO NOT CHANGE!!
// To build run: NODE_ENV=production ng build --configuration=production
// To serve run: NODE_ENV=production ng serve --configuration=production

import { KeycloakConfig } from 'keycloak-js';
//import keycloakConfig from './keycloak.config';

export const environment = {
  production: true,
  Name: 'production',
  Version: '1.0.0',
    //GoogleApiKey: 'AIzaSyCNkrNw6LSXNcBMJeoev1cRUAOSRN7Q82o', EXPIRED?
  GoogleApiKey: 'AIzaSyAi2s4UG5fzRx2m_0v5lLDDgeC01TyCnuM',
  PollingInterval: 60000, // milliseconds
  FilesUploadApi : {
    Url : "https://files.sky.sethala.com",
    Auth : 'Basic N2RCVjNyMWg0NUJNR0FTY0JXbGZ3bmFWRllIZ0dmOkNPWUo4NVBGcEVhOGJFSFdIbFIwM2hRNnZpUElnVGNyT2xYM1hqcGxpUDNuYmhGV2dP'
  },
  SethalaIndoorApi: {
    //Azure Production Api
    //Url: 'https://debeers-api.indoor.sethala.app',
    //Sky A6 Production Api
    Url: 'https://indoor-api.sethala.net',
    PlatformId: '629c712e-9bcb-4e0b-a50a-46af4eac6c8a',
    AuthenticationKey: 'IXJ3paodOc2eW2cjv0cf617xOicij7Fz',
  },
  SethalaKhiyaApi: {
    ClientId: 'Indoor.Webapp',
    Url: 'https://khiya.sethala.app',
    GrantType: 'password',
    Realm: 'dbsssa',
  },
  SethalaCore: {
    Url: 'https://api-nkosi-prod-nsa.sethala.app/v2',
  },
  mqtt: {
		server: 'sky1.sethala.com',
    username: 'sethala-dev',
    password:'Q98Vb6Ctq2J328-22',
		protocol: 'wss',
		port: 8083
	},
  // REAL PROD ( AZURE RS: UPDATE GATEWAYS TO CONNECT TO NEW ENV FIRST THEN ENABLE THIS)
  // mqtt: {
  //   server: 'datagate.sethala.com',
  //   username: 'debeers-indoor',
  //   password: 'juH26k8oT8KDQ6T7L',
  //   protocol: 'wss',
  //   port: 8083,
  // },
  keycloak: {
    url: 'https://khiya.sethala.app',
    realm: 'dbsssa',
    clientId: 'Indoor.Webapp',
  },
  appMandetoryRole: ['default-roles-sethala'],
};